export const connectorFormatsDto = ['SOCKET', 'CABLE'] as const;
export type ConnectorFormatDto = (typeof connectorFormatsDto)[number];
